import { Injectable } from 'angular-ts-decorators';

import { assign, find } from 'lodash';

import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { Initable } from '@shared/app/scripts/services/initable';
import { Location } from '@shared/app/scripts/services/location';
import { LocationModel } from '@classes/location-model';

/**
 * Service that loads all data related to locations
 */
@Injectable('locationManager')
export class LocationManager implements Initable {
  dependencies: ['session'];

  constructor(
    private location: Location,
    private currentSession: CurrentSession,
  ) {
    'ngInject';
  }

  /**
   * The info about the current location.
   */
  current: Partial<LocationModel> = {};

  /**
   * True, when data is loaded
   */
  loaded: boolean = false;

  /**
   * A list of all locations available for the tenant.
   */
  all: LocationModel[] = [];

  /**
   * Loads necessary data.
   * @return
   * A promise that resolves with the current location
   */
  init(): ng.IPromise<any> {
    return this.location
      .filter({ active: true }, undefined, 250)
      .then((locations) => {
        this.all = locations;

        this.current = find(this.all, { wh: this.currentSession.warehouse });

        this.loaded = true;

        const mainAddress = find(this.current.addresses, {
          type: 'main',
        });

        if (mainAddress) {
          assign(this.current, mainAddress);
        }

        return this.current;
      });
  }
}
